import React from 'react';

import { mobile, tablet, desktop, touchDevice } from 'is_js';

export const deviceInfo = {
  isMobile: mobile(),
  isTablet: tablet(),
  isDesktop: desktop(),
  isTouchDevice: !desktop() && touchDevice(),
};

const deviceInfoContext = React.createContext(deviceInfo);

export default deviceInfoContext;
